import React from 'react';
import { useSelector } from 'react-redux';
import { selectStoreCount } from 'core/selectors/app';

import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import './HIWSection.scss';

function HIWSection() {
  const storeCount = useSelector(selectStoreCount);

  return (
    <div className="mn_hiwSection">
      <ContentWrap>
        <SectionTitle title="Miles add up quickly&mdash;just for shopping." />
        <div className="mn_hiwItems">
          <div className="mn_hiwItem" data-test="hiw-item-explore">
            <div className="mn_hiwItemContent">
              <div className="mn_icon mn_exploreIcon" />
              <h3 className="mn_hiwItemHeader">Explore</h3>
              <p className="mn_hiwItemInfo">
                {`Explore over ${storeCount} stores, exclusive offers and bonus promotions, all in one place.`}
              </p>
            </div>
          </div>

          <div className="mn_hiwItem" data-test="hiw-item-click">
            <div className="mn_hiwItemContent">
              <div className="mn_icon mn_clickIcon" />
              <h3 className="mn_hiwItemHeader">Shop online</h3>
              <p className="mn_hiwItemInfo">Shop at the store site and checkout as you normally would.</p>
            </div>
          </div>

          <div className="mn_hiwItem" data-test="hiw-item-shop">
            <div className="mn_hiwItemContent">
              <div className="mn_icon mn_shopIcon" />
              <h3 className="mn_hiwItemHeader">Shop in-store</h3>
              <p className="mn_hiwItemInfo">
                Link offers to your preferred card. Shop in-store and pay with your linked card.
              </p>
            </div>
          </div>

          <div className="mn_hiwItem" data-test="hiw-item-earn">
            <div className="mn_hiwItemContent">
              <div className="mn_icon mn_earnIcon" />
              <h3 className="mn_hiwItemHeader">Earn</h3>
              <p className="mn_hiwItemInfo">
                After your purchase, miles earned will be added to your MileagePlus account.
              </p>
            </div>
          </div>
        </div>
      </ContentWrap>
    </div>
  );
}

export default HIWSection;
